<template lang="pug">
.container.center-box
  VeeForm(ref="form")
    form.row.center-box-inner(autocomplete="off")

      h4 補助案名稱：{{data.grant_name}} {{ name }}
        hr
        h6.text-md-left 請填寫以下相關資料：
      Vee(rules="required" v-slot="{errors}" tag="div").mb-3.w-100
        .input-group
          .input-group-prepend
            label.input-group-text.width-s.justify-content-end.required(for="activity_name") 活動名稱
          input#activity_name.form-control(v-model="data.activity_name" type="text")
        .input-err-msg {{errors[0]}}

      Vee(rules="required" v-slot="{errors}" tag="div").mb-3.w-100
        .input-group
          .input-group-prepend
            label.input-group-text.width-s.justify-content-end.required(for="city") 縣市
          select.custom-select#city(v-model="data.city" )
            option(value="" selected disabled) 請選擇縣市別
            option(value="基隆市") 基隆市
            option(value="臺北市") 臺北市
            option(value="新北市") 新北市
            option(value="桃園市") 桃園市
            option(value="新竹市") 新竹市
            option(value="新竹縣") 新竹縣
            option(value="苗栗縣") 苗栗縣
            option(value="臺中市") 臺中市
            option(value="彰化縣") 彰化縣
            option(value="南投縣") 南投縣
            option(value="雲林縣") 雲林縣
            option(value="嘉義市") 嘉義市
            option(value="嘉義縣") 嘉義縣
            option(value="臺南市") 臺南市
            option(value="高雄市") 高雄市
            option(value="屏東縣") 屏東縣
            option(value="宜蘭縣") 宜蘭縣
            option(value="花蓮縣") 花蓮縣
            option(value="臺東縣") 臺東縣
            option(value="澎湖縣") 澎湖縣
            option(value="金門縣") 金門縣
            option(value="連江縣") 連江縣
        .input-err-msg {{errors[0]}}
      Vee(rules="required" v-slot="{errors}" tag="div").mb-3.w-100
        .input-group
          .input-group-prepend
            label.input-group-text.width-s.justify-content-end.required(for="org_type") 單位類別
          select.custom-select#org_type(v-model="data.org_type")
            option(value="" selected disabled) 請選擇單位類別
            option(value="1") 民團
            option(value="2") 大學
            option(value="3") 中等學校以下
            option(value="4") 公家機關

        .input-err-msg {{errors[0]}}

      Vee(rules="required" v-slot="{errors}" tag="div").mb-3.w-100
        .input-group
          .input-group-prepend
            label.input-group-text.width-s.justify-content-end.required(for="org_name") 申請單位
          input.form-control#org_name(v-model="data.org_name" type="text" placeholder="請填機關、團體、學校全銜")
        .input-err-msg {{errors[0]}}
      .mb-3.text-secondary 申請兩案以上者，請在單位名稱後方註記1、2...以示區別。範例: OO單位1、OO單位2。
      Vee(rules="required|number" v-slot="{errors}" tag="div").mb-3.w-100
        .input-group
          .input-group-prepend
            label.input-group-text.width-s.justify-content-end.required(for="org_number") 統一編號
          input.form-control#org_number(v-model="data.org_number" type="text")
        .input-err-msg {{errors[0]}}
      Vee(rules="required" v-slot="{errors}" tag="div").mb-3.w-100
        .input-group
          .input-group-prepend
            label.input-group-text.width-s.justify-content-end.required(for="boss") 負責人
          input#boss.form-control(v-model="data.boss" type="text")
        .input-err-msg {{errors[0]}}
      Vee(rules="required" v-slot="{errors}" tag="div").mb-3.w-100
        .input-group
          .input-group-prepend
            label.input-group-text.width-s.justify-content-end.required(for="address") 地址
          input#address.form-control(v-model="data.address" type="text", placeholder="請填寫詳細收件地址")
        .input-err-msg {{errors[0]}}

      .mb-3.w-100
        .input-group
          .input-group-prepend
            label.input-group-text.width-s.justify-content-end.required 活動類型
          Vee(rules="required" ref="classInput").form-control
            .form-check.form-check-inline(v-for="(e, i) in defaultClassList" :key="e")
              input.form-check-input(:id="`activity_class${i+1}`" v-model="data.activity_class" type="checkbox" :value="e")
              label.form-check-label(:for="`activity_class${i+1}`") {{e}}
          Vee(v-if="data.activity_class.includes('其他')" rules="required" ref="classInputElseValue").input-group-append
            input.form-control.else-input(
              v-model="elseActivityClassValue"
              type="text"
              placeholder="若選擇「其他」請說明:"
            )
        .input-err-msg {{classError}}
      .mb-3.w-100
        .input-group
          .input-group-prepend
            label.input-group-text.width-s.justify-content-end.required 活動形式
          Vee(rules="required" ref="typeInput").form-control
            .form-check.form-check-inline(v-for="(e, i) in defaultTypeList" :key="e")
              input.form-check-input(:id="`activity_type${i+1}`" v-model="data.activity_type" type="checkbox" :value="e")
              label.form-check-label(:for="`activity_type${i+1}`") {{e}}
          Vee(v-if="data.activity_type.includes('其他')" rules="required" ref="typeInputElseValue").input-group-append
            input.form-control.else-input(
              v-model="elseActivityTypeValue"
              type="text"
              placeholder="若選擇「其他」請說明:"
            )
        .input-err-msg {{TypeError}}
      .row.mb-3
        Vee(rules="required|positive" v-slot="{errors}").col-sm-12.col-md-4.mb-sm-1
          .input-group
            .input-group-prepend
              label.input-group-text.width-s.justify-content-end.required(for="activity_hours") 時數
            input#activity_hours.form-control(v-model="data.activity_hours" type="number" placeholder="時數")
          .input-err-msg {{errors[0]}}
        Vee(rules="required|positive" v-slot="{errors}").col-sm-12.col-md-4.mb-sm-1
          .input-group
            .input-group-prepend
              label.input-group-text.width-s.justify-content-end.required(for="activity_counter") 場次
            input#activity_counter.form-control(v-model="data.activity_counter" type="number" placeholder="場次")
          .input-err-msg {{errors[0]}}

        Vee(rules="required|positive" v-slot="{errors}").col-sm-12.col-md-4.mb-sm-1
          .input-group
            .input-group-prepend
              label.input-group-text.width-s.justify-content-end.required(for="activity_number") 參加人數
            input#activity_number.form-control(v-model="data.activity_number" type="number" placeholder="參加人數")
          .input-err-msg {{errors[0]}}

      .mb-3.w-100
        .input-group
          .input-group-prepend
            label.input-group-text.width-s.justify-content-end.required 辦理期間
          Vee(rules="required" ref="dateStart").form-control
            label(for="start")  開始日:
            input.date-input#start(v-model="data.activity_starttime" type="date", value="2022-02-22", min="2022-01-01", max="2030-12-31")
          Vee(rules="required" ref="dateEnd").form-control
            label(for="end")  結束日:
            input.date-input#end(v-model="data.activity_endtime" type="date", value="2022-02-22", min="2022-01-01", max="2030-12-31")
        .input-err-msg {{dateError}}
      .mb-3.text-danger 請填辦理期間起訖日期，計畫期程如有變更請備文到教育部

      Vee(rules="required|positive" v-slot="{errors}").mb-3.w-100
        .input-group
          .input-group-prepend
            label.input-group-text.width-s.justify-content-end.required(for="activity_amount") 計畫經費總額
            label.input-group-text $
          input#activity_amount.form-control(v-model="data.activity_amount" type="number" placeholder="填寫計畫所需總金額")
        .input-err-msg {{errors[0]}}

      .mb-3.w-100
        .input-group
          .input-group-prepend
            label.input-group-text.width-s.justify-content-end.required() 是否有門票或其他收入
          .form-control
            .form-check.form-check-inline
              .form-check
                input.form-check-input#flexRadioDefault1(
                  v-model="ticketIncome"
                  type="radio"
                  :value="false"
                )
                label.form-check-label(for="flexRadioDefault1") 否
              .form-check
                input.form-check-input#flexRadioDefault2(
                  v-model="ticketIncome"
                  type="radio"
                  :value="true"
                )
                label.form-check-label(for="flexRadioDefault2") 是
          .input-group-prepend(v-if="ticketIncome")
            label.input-group-text $
          Vee(v-if="ticketIncome" rules="required|positive" ref="ticketIncomeEl")
            input.money-input.form-control(v-model.number="data.ticket_income" type="number" placeholder="100")
          .input-group-append
            span.input-group-text 元
        .input-err-msg {{ticketIncomeError}}

      Vee(rules="required|positive|maxNum:400000" v-slot="{errors}").mb-3.w-100
        .input-group
          .input-group-prepend
            label.input-group-text.width-s.justify-content-end.required(for="subsidy") 向本案申請補助金額
            label.input-group-text $
          input#subsidy.form-control(
            v-model.number="data.subsidy"
            type="number"
            placeholder="0"
            @change="checkSubsidyLimit"
            @blur="checkSubsidyLimit"
          )
          .input-group-append
            span.input-group-text 元
          .input-group-append
            // 顯示 subsidy_limit 時，需注意型別與 fallback
            span.input-group-text.text-danger 補助案每件限額(NTD$): {{ (subsidy_limit && Number(subsidy_limit) > 0) ? subsidy_limit : '未設定' }} 元
        .input-err-msg {{errors[0]}}
      .row.mb-3
        .col-sm-12.col-md-6.pb-0
          .input-group.w-100
            .input-group-prepend
              label.input-group-text.width-s.justify-content-end.required 112年教育部補助情形
            Vee(rules="positive" ref="oldSubsidy1Number").w-25
              input.form-control(v-model="data.old_subsidy[0].number" type="number" placeholder="件數")
            Vee(rules="positive" ref="oldSubsidy1Amount").w-25
              input.form-control(v-model="data.old_subsidy[0].amount" type="number" placeholder="金額")
        .col-sm-12.col-md-6.pb-0
          .input-group.w-100
            .input-group-prepend
              label.input-group-text.width-s.justify-content-end.required 111年教育部補助情形
            Vee(rules="required|positive" ref="oldSubsidy2Number").w-25
              input.form-control(v-model="data.old_subsidy[1].number" type="number" placeholder="件數")
            Vee(rules="required|positive" ref="oldSubsidy2Amount").w-25
              input.form-control(v-model="data.old_subsidy[1].amount" type="number" placeholder="金額")
        .col-12.py-0.input-err-msg {{oldSubsidyError}}


      Vee(rules="required" v-slot="{errors}").mb-3.w-100
        .input-group
          .input-group-prepend
            label.input-group-text.width-s.justify-content-end.required(for="subsidy_other") 向其他機關及民團申請補助款
          input#subsidy_other.form-control(v-model.number ="data.subsidy_other" type="text", style="display: unset;width:150px;")
          .input-group-append
            span.input-group-text 元
        .input-err-msg {{errors[0]}}
      .mb-3.text-danger 例:文化部5萬，沒有請填 0 元

      Vee(rules="required|positive" v-slot="{errors}").mb-3.w-100
        .input-group
          .input-group-prepend
            label.input-group-text.width-s.justify-content-end.required(for="self_raising") 貴單位自籌款
          input#self_raising.form-control(v-model.number="data.self_raising" type="number", style="display: unset;width:150px;")
          .input-group-append
            span.input-group-text 元
        .input-err-msg {{errors[0]}}
      .mb-3.text-danger <span class="font-weight-bold text-success">貴單位自籌款 = </span><span class="font-weight-bold text-primary">計畫經費總額 - 向本案申請補助金額 - 向其他機關及民團申請補助款</span>




      Vee(rules="required" v-slot="{errors}").mb-3.w-100
        .input-group
          .input-group-prepend
            label.input-group-text.width-s.justify-content-end.required(for="contact_name") 聯絡人姓名
          input#contact_name.form-control(v-model="data.contact_name" type="text")
        .input-err-msg {{errors[0]}}
      Vee(rules="required|phone" v-slot="{errors}").mb-3.w-100
        .input-group
          .input-group-prepend
            label.input-group-text.width-s.justify-content-end.required(for="contact_phone") 聯絡人電話
          input#contact_phone.form-control(v-model="data.contact_phone" type="phone")
        .input-err-msg {{errors[0]}}
      Vee(rules="required|email" v-slot="{errors}").mb-3.w-100
        .input-group
          .input-group-prepend
            label.input-group-text.width-s.justify-content-end.required(for="contact_email") 聯絡人 email
          input#contact_email.form-control(:disabled="applicationId" v-model="data.contact_email" type="email" placeholder="請輸入【資料維護】用帳號")
        .input-err-msg {{errors[0]}}

      template(v-if="!applicationId")
        Vee(rules="required|psw" v-slot="{errors}").mb-3.w-100
          .input-group
            .input-group-prepend
              span.pwunput.input-group-text.width-s.justify-content-end.required(for="psw") 密碼： <span class="text-primary">( 請輸入【資料維護】用密碼 )</span>
            input#psw.form-control.pwinput(@input='handleInput', v-model='psw', :type="showPassword ? 'text' : 'password'", v-bind:placeholder='placeholder', autocomplete='off')
            .input-group-append
              .input-group-text(:class="{'cursor-pointer':showPointer}", @click='showPassword = !showPassword', @mouseout='showPointer = false', @mouseover='showPointer = true')
                b-icon-eye(v-if='! showPassword')
                b-icon-eye-fill(v-if='showPassword')
          .input-err-msg {{errors[0]}}
          .psw-note.mt-2
            strong.text-secondary 請注意密碼強度規則﹔
            ol
              li 最少8位數，英文字母及數字混合
              li 要有大、小寫組合的英文字母
              li 要有一個特殊符號(@#$%^&+=)
              li 要使用半形輸入

      FileUploader(
        :files.sync="data.attach_files"
        :removeFileIds.sync="removeFileIds"
        title="上傳相關申請的附件資料檔案"
      )

      p.text-danger *** 請注意!! ***
        br
        span 1.上傳檔案限制:20MB
        br
        span 2.請將活動申請表甲表(用印)、乙表、丙表(用印)及活動計畫書，掃描合併成pdf檔案後再上傳。
        br
        span 3.增加為配合政府推動ODF-CNS15251為政府標準格式，可編輯文件、表單優先上傳ODF文件格式、不可編輯之文件優先上傳PDF文件格式。

      .input-group.my-3.flex-nowrap
        .input-group-prepend
          label.input-group-text.width-s.justify-content-end(for="city_contact_info_city") 縣市窗口
        input#city_contact_info_city.form-control(v-model="data.city_contact_info.unit_name" type="text" placeholder="單位名稱")
      .input-group.mb-3.flex-nowrap
        .input-group-prepend
          label.input-group-text.width-s.justify-content-end(for="city_contact_info_name") 承辦人
        input#city_contact_info_name.form-control(v-model="data.city_contact_info.name" type="text" placeholder="縣市窗口的承辦人")
      Vee(rules="phone" v-slot="{errors}").mb-3.w-100
        .input-group
          .input-group-prepend
            label.input-group-text.width-s.justify-content-end(for="city_contact_info_phone") 連絡電話
          input#city_contact_info_phone.form-control(v-model="data.city_contact_info.phone" type="text" placeholder="承辦人的聯絡電話")
        .input-err-msg {{errors[0]}}
      Vee(rules="email" v-slot="{errors}").mb-3.w-100
        .input-group
          .input-group-prepend
            label.input-group-text.width-s.justify-content-end(for="city_contact_info_email") email
          input#city_contact_info_email.form-control(
            v-model="data.city_contact_info.email"
            type="text"
            placeholder="承辦人的email帳號"
            )
        .input-err-msg {{errors[0]}}

      .mb-3.text-dark 高級中等以下學校，請務必留下所屬之教育主管行政機關承辦人聯絡資訊（*縣市窗口承辦人姓名/電話/email信箱），俾利所屬教育局處掌握轄內申請補助情形。
        hr
        p.text-dark ✯ 請留意截止收件時間，收件時間以實際頁面資料送出為準 ✯
        p.text-dark 目前時間: <span class="text-primary">{{ timestamp  }}</span>
        <!-- p.text-dark 截止收件時間: <span class="text-danger"> {{ get_endTime }} </span> -->
        p.text-dark 填寫上有問題可於上班日09:00~17:00來電：
        p 申請填寫問題請洽：<span class="font-weight-bold text-info">教育部 師資培育及藝術教育司 陳小姐：02-7736-6717</span>


      .input-group.flex-nowrap.mt-3
        button.btn.btn-success.btn-lg(type="button" @click="submit")
          span.text-light 確認無誤



</template>

<script>
import { fetchGrantApplicationDetail, updateGrantApplication } from '@/api/client/Grant'
import FileUploader from './FileUploader'
import { extend } from 'vee-validate'
import { BIconEye, BIconEyeFill } from 'bootstrap-vue'
extend('psw', {
  validate(value) {
    const minLength = 8
    const symbols = '@#$%^&+='
    if (value.length < minLength) return false
    if (
      value.split('').every(e => e === e.toLowerCase()) ||
      value.split('').every(e => e === e.toUpperCase())
    ) return false
    if (!value.split('').find(e  => symbols.includes(e))) return false
    const fullWidthList = value.match(/[\uff00-\uffff]/g)
    if (fullWidthList) return false
    return true
  },
  message: '密碼不符合要求！'
})
export default {
  components: {
    FileUploader,
    BIconEye,
    BIconEyeFill
  },
  name: 'PasswordInput',
    props: {
    placeholder: String,
    value: String
  },
  data () {

    return {
      showPassword: false,
      showPointer: false,
      password: this.value,
      name: "",
      timestamp: "",
      isMounted: false,
      defaultClassList: ['美術', '音樂', '戲劇(曲)', '舞蹈', '視聽媒體藝術', '其他'],
      defaultTypeList: ['課程與教學', '展覽', '表演', '研習', '比賽', '其他'],
      psw: null,
      grantId: null,
      applicationId: null,
      get_endTime: null,
      u_str: null,
      subsidy_limit: null, // 新增 subsidy_limit 變數
      data: {
        grant_name: null,
        city: null,
        org_type: null,
        org_name: null,
        org_number: null,
        boss: null,
        address: null,
        activity_name: null,
        activity_class: [],
        activity_type: [],
        activity_hours: null,
        activity_counter: null,
        activity_number: null,
        activity_amount: null,
        ticket_income: null,
        subsidy: null,
        old_subsidy: [{ amount: null, number: null }, { amount: null, number: null }],
        activity_starttime: null,
        activity_endtime: null,
        self_raising: null,
        subsidy_other: null,
        contact_name: null,
        contact_phone: null,
        contact_email: null,
        city_contact_info: {
          unit_name: null,
          name: null,
          email: null,
          phone: null
        },
        attach_files: [],

      },
      elseActivityClassValue: null,
      elseActivityTypeValue: null,
      removeFileIds: []
    }
  },
  computed: {
    isCreate () {
      return this.$route.path.includes('create')
    },
    addressError () {
      if (!this.isMounted) return ''
      if (this.$refs.addressInput.errors.length) return this.$refs.addressInput.errors[0]
      return ''
    },
    classError () {
      if (!this.isMounted) return ''
      let errors = []
      if (this.$refs.classInput.errors) errors = errors.concat(this.$refs.classInput.errors)
      if (this.$refs.classInputElseValue) {
        errors = errors.concat(this.$refs.classInputElseValue.errors)
      }
      if (errors.length) return errors[0]
      return ''
    },
    TypeError () {
      if (!this.isMounted) return ''
      let errors = []
      if (this.$refs.typeInput.errors) errors = errors.concat(this.$refs.typeInput.errors)
      if (this.$refs.typeInputElseValue) {
        errors = errors.concat(this.$refs.typeInputElseValue.errors)
      }
      if (errors.length) return errors[0]
      return ''
    },
    oldSubsidyError () {
      if (!this.isMounted) return ''
      let errors = []
      if (this.$refs.oldSubsidy1Number) errors = errors.concat(this.$refs.oldSubsidy1Number.errors)
      if (this.$refs.oldSubsidy2Number) errors = errors.concat(this.$refs.oldSubsidy2Number.errors)
      if (this.$refs.oldSubsidy1Amount) errors = errors.concat(this.$refs.oldSubsidy1Amount.errors)
      if (this.$refs.oldSubsidy2Amount) errors = errors.concat(this.$refs.oldSubsidy2Amount.errors)
      if (errors.length) return errors[0]
      return ''
    },
    ticketIncome: {
      get () {
        if (this.data.ticket_income == null) return false
        return true
      },
      set (nv) {
        if (nv) {
          this.data.ticket_income = 0
          return
        }
        this.data.ticket_income = null
      }
    },
    ticketIncomeError () {
      if (!this.isMounted) return ''
      if (!this.ticketIncome) return ''
      let errors = []
      if (this.$refs.ticketIncomeEl) {
        errors = errors.concat(this.$refs.ticketIncomeEl.errors)
      }
      if (errors.length) return errors[0]
      return ''
    },
    dateError () {
      if (!this.isMounted) return ''
      let errors = []
      if (this.$refs.dateStart) errors = errors.concat(this.$refs.dateStart.errors)
      if (this.$refs.dateEnd) errors = errors.concat(this.$refs.dateEnd.errors)
      if (errors.length) return errors[0]
      return ''
    }
  },
  created()
  {
     setInterval(this.getNow, 1000);
  },
  methods: {
    handleInput (e) {
      this.$emit('input', this.password)
    },
    getNow: function() {
      const today = new Date();
      const date = today.getFullYear()+'年'+(today.getMonth()+1)+'月'+today.getDate()+'日';
      const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      const dateTime = date +' '+ time;
      this.timestamp = dateTime;

    },
    onUpload (file, index, event) {
      const { files } = event.target
      // console.log(file, files)
      this.data.attach_files[index].file = files[0]
    },
    toggleRemoveFile (file, index) {
      const { id } = file
      if (!id) {
        this.data.attach_files.splice(index, 1)
        return
      }
      if (this.removeFileIds.includes(id)) {
        this.removeFileIds = this.removeFileIds.filter(e => e !== id)
        return
      }
      this.removeFileIds.push(id)
      this.removeFileIds = [...new Set(this.removeFileIds)]

    },
    downloadFile (file) {
      if (!file.src) {
        return
      }
      const link = document.createElement('a')
      link.href = file.src
      link.target = '_blank'
      link.click()
    },
    addEmptyFile () {
      this.data.attach_files.push({ file: null, src: null })
    },
    async fetchData ({ u_str, applicationId }) {
      const { data } = await fetchGrantApplicationDetail({ u_str, applicationId })
      const { activity_class, activity_type, subsidy_limit, name } = data
      console.log(subsidy_limit);
      this.subsidy_limit = subsidy_limit // 存到外層
      this.name = name // 參考這一行
      this.data = {
        ...this.data,
        ...data,
        activity_counter: 1,
        activity_type: activity_type.map(e => {
          if (!this.defaultTypeList.includes(e)) {
            this.elseActivityTypeValue = e
            return '其他'
          }
          return e
        }),
        activity_class: activity_class.map(e => {
          if (!this.defaultClassList.includes(e)) {
            this.elseActivityClassValue = e
            return '其他'
          }
          return e
        }),
      }
    },
    async submit () {
      try {
        // 申請金額檢查
        if (
          this.subsidy_limit &&
          Number(this.data.subsidy) > Number(this.subsidy_limit)
        ) {
          alert(`申請金額不可超過補助案每件限額(NTD$): ${this.subsidy_limit} 元`)
          return
        }
        const { form } = this.$refs
        const success = await form.validate()
        if (!success) {
          const target = form.$children.find(ref => ref.errors && ref.errors.length > 0)
          const input = target.$el.querySelector('input')
          const select = target.$el.querySelector('select')
          const el = input || select
          console.log(target)
          if (el) el.focus()
          return
        }
        const payload = {
          u_str: this.u_str,
          grant_id: this.grantId,
          application_id: this.applicationId,
          contact_passwd: this.psw,
          ...this.data,
          activity_type: this.data.activity_type.map((e, i) => e === '其他' ? this.elseActivityTypeValue : e),
          activity_class: this.data.activity_class.map((e, i) => e === '其他' ? this.elseActivityClassValue : e)
        }
        const addFiles = this.data.attach_files.filter(e => e.file).map(e => e.file)
        const removeFileIds = this.removeFileIds
        const { errcode, errmsg } = await updateGrantApplication(payload, addFiles, removeFileIds)
        if (errcode || errmsg) throw new Error(errmsg)
        this.$router.push({ path: '/artedu1872/subsidy/grantApplicationList' })
      } catch (err) {
        console.warn(err)
        //alert('提交資料連線逾時，請確認是否申請成功！')
        this.$router.push({ path: '/artedu1872/subsidy/grantApplicationList' })
      }
    },
    checkSubsidyLimit() {
      // 增加一個 flag，避免重複 alert
      if (!this._subsidyAlerted) this._subsidyAlerted = false
      if (
        this.subsidy_limit &&
        Number(this.data.subsidy) > Number(this.subsidy_limit)
      ) {
        if (!this._subsidyAlerted) {
          alert(`申請金額不可超過補助案每件限額(NTD$): ${this.subsidy_limit} 元`)
          this._subsidyAlerted = true
        }
      } else {
        this._subsidyAlerted = false
      }
    }
  },
  async mounted () {
    try {
      this.isMounted = true
      const { id: applicationId, grantId, end_time, name, subsidy_limit } = this.$route.query
      this.name = name
      this.applicationId = applicationId
      this.get_endTime = end_time
      // 若 subsidy_limit 有在 query 直接帶入
      if (subsidy_limit) {
        this.subsidy_limit = subsidy_limit
      }
      //console.log(this.get_endTime)
      if (grantId) {
        this.grantId = grantId
        return
      }
      const user = sessionStorage.getItem('user')
      if (!user) throw new Error('no user')
      const { u_str } = JSON.parse(user)
      if (!u_str) return
      this.u_str = u_str
      await this.fetchData({ u_str, applicationId })
    } catch (err) {
      console.warn(err)
      //this.$router.push({ name: 'UploadData' })
      this.$router.push({ path: '/artedu1872/subsidy/uploadData' })
    }
  }
}
</script>

<style lang="sass" scoped>
.new-line
  display: block
  width: 400px
.input-group
  position: relative
.form-control
  position: static
.pos-abs
  position: absolute
.input-err-msg
  color: red
.psw-note
  font-size: 12px
  padding: 0 1rem
  margin-top: 0
input.money-input
  max-width: 150px
input.else-input
  max-width: 200px
span.required:before, label.required:before
  content: "*"
  color: red
</style>



// WEBPACK FOOTER //
// src/views/Artedu1872/components/UploadData/Maintain.vue